import { styled } from "@material-ui/core";
import Typography from "components/Typography";

export const RichMenuTypography = styled(Typography)({
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "pre-wrap",
});
